import styled from 'styled-components';
import {
  space, color, layout, border, flexbox,
} from 'styled-system';

const Box = styled.div(
  {
    boxSizing: 'border-box',
  },
  space,
  color,
  layout,
  border,
  flexbox,
);
export default Box;
